import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section className="py-24 px-4 bg-white" data-id="element-122" data-mp="2lmspylv9v6kb">
      <div className="max-w-4xl mx-auto" data-id="element-123" data-mp="26yfudq03jpqc">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-124" data-mp="26xmsb2c31oej">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-[#081632]" data-id="element-125" data-mp="21z37545bcgn8">
            Does this sound familiar?
          </h2>
          <div className="text-lg text-slate-700 leading-relaxed bg-white p-6 rounded-2xl border border-[#D89B16]/40 shadow-sm shadow-[#1E4ED8]/10 text-left space-y-4" data-id="element-126" data-mp="1o0vayyg3pjd4">
            <p data-id="element-127" data-mp="3id2znu1tx40g">Sunday evening. You have another Judo session coming up.</p>
            <p data-id="element-128" data-mp="3nco0ka0k7mft">
              And instead of resting, you are still looking for drills, deciding which throws to
              teach, thinking about how to progress the session and wondering whether the class will
              really make sense for the athletes in front of you.
            </p>
            <p data-id="element-129" data-mp="27sz389owk0y2">
              <span className="text-[#081632] font-semibold" data-id="element-130" data-mp="27sqn88xhgfin">
                Not because you don&apos;t know Judo.
              </span>{' '}
              Because knowing Judo and having a complete, structured coaching system are two
              different things.
            </p>
            <p className="text-[#081632] font-semibold" data-id="element-131" data-mp="1b2pszuech6ty">
              Without a system, every session starts from zero.
            </p>
            <p data-id="element-132" data-mp="1p3k3cikydhv9">
              You search for ideas. You repeat drills you already know. You improvise the
              progression. You hope the session feels connected.
            </p>
            <p data-id="element-133" data-mp="30h4m0qwebfv9">And the time that should be recovery time becomes planning time.</p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-134" data-mp="2vhjgfxmq099k">
          <h3 className="text-xl font-bold text-[#081632] mb-8 text-center" data-id="element-135" data-mp="1y2ewned0urfk">
            The real cost of planning everything from scratch:
          </h3>
          <div className="overflow-hidden rounded-xl border border-[#D89B16]/40 bg-white shadow-sm shadow-[#1E4ED8]/10" data-id="element-136" data-mp="275g2ddxz6gip">
            {painPoints.map((point, index) => <motion.p key={point} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="px-5 py-4 text-slate-700 text-sm leading-relaxed border-t first:border-t-0 border-[#D89B16]/30" data-id="element-137" data-mp="1acuf8zwio28e" data-mpi={index}>
                <span className="mr-2 text-[#D89B16]" data-id="element-138" data-mp="vp9db9bdo922">●</span>
                {point}
              </motion.p>)}
          </div>

          <div className="text-center mt-12 pt-8 border-t border-[#D89B16]/30" data-id="element-139" data-mp="o5gu6mndksa2">
            <p className="text-2xl font-serif font-bold text-[#081632]" data-id="element-140" data-mp="j8goicuftrjh">
              Your Judo knowledge is already there. What you need is a{' '}
              <span className="text-[#D89B16]" data-id="element-141" data-mp="a6h6piblmjfh">system</span> that helps you use it faster, more
              consistently and more professionally.
            </p>
            <p className="text-xl mt-4 text-[#1E4ED8] font-semibold" data-id="element-142" data-mp="58yt3emmzg15">
              Solve months of Judo session planning in just 5 MINUTES
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}